export enum ActionType {
  SET_LANG_VALUE = "setLangValue",
  SET_NAME = "setName",
  SET_FREEZ_SCREEN = "setFreezScreen",
  SET_ALERT_MESSAGE = "setAlertMessages",
  SET_RESET_STATE = "SET_RESET_STATE",
  SET_FORMDATA = "setFormData",
  SET_SHOP_URL = "setShopUrl",
  SET_USER_INFO = "setUserInfo",
  SET_ORDER_EVENT_TABLE = "setOrderEventTable",
  SET_LOGGED_IN = "setLoggedIn",
  SET_QR_CODE = "setQrCode",
  SET_SHARE_QR_CODE = "setShareQrcode",
  SET_QR_INDEX = "setQrIndex",
  SET_STORE_MANAGER_LIST = "SET_STORE_MANAGER_LIST",
  SET_STORE_ID = "SET_STORE_ID",
  SET_SEGMENT_SETTINGS = "SET_SEGMENT_SETTINGS",
  SET_CUSTOMER_SEGMENT_INFO = "SET_CUSTOMER_SEGMENT_INFO",
  SET_PAYMENT_METHOD_POPUP = "SET_PAYMENT_METHOD_POPUP",
  SET_STORE_INFO = "SET_STORE_INFO",
  SET_BOOKING_DETAILS = "SET_BOOKING_DETAILS",
  SET_EXTRAS_FIELDS_POPUP = "SET_EXTRAS_FIELDS_POPUP",
  SET_EXTRAS_FIELDS = "SET_EXTRAS_FIELDS",
  SET_CART = "SET_CART",
  SET_BOOKING_FORM = "SET_BOOKING_FORM",
  SET_AUTH_TOKEN = "SET_AUTH_TOKEN",
  SET_DEVICE_ID = "SET_DEVICE_ID",
  SET_BOOKING_TOTAL = "SET_BOOKING_TOTAL",
  SET_SLOTS_LIST = "SET_SLOTS_LIST",
  SET_TIME_CACHE_CREATED_AT = "SET_TIME_CACHE_CREATED_AT",
  SET_REDIRECT_CHECKOUT = "SET_REDIRECT_CHECKOUT",
  SET_LOGIN_MODAL = "SET_LOGIN_MODAL",
  SET_OTP_MODAL = "SET_OTP_MODAL",
  SET_LOGIN_STATE = "SET_LOGIN_STATE",
  SET_LOGIN_SKIP = "SET_LOGIN_SKIP",
  SET_GUEST_LOGGED_IN = "SET_GUEST_LOGGED_IN",
  SET_PENDING_CHECKOUT = "SET_PENDING_CHECKOUT"
}
